import { Paper, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ProductForm from "../../../components/ProductForm/ProductForm";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Save, X } from "react-feather";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useSelector } from "react-redux";
import ConfirmationPopup from "../../../components/ConfirmationPopup/ConfirmationPopup";

const CreateProductPage = ({ setPageID, setPageLink }) => {
  const history = useHistory();
  const location = useLocation();

  /*Get prodCat permission from redux*/
  const takeoffWiz = useSelector((state) =>
    state.user.user ? state.user.user.user.role.takeoffWiz : ""
  );
  /*Redirection*/
  if (takeoffWiz !== "M") {
    history.push("/dashboard");
  }

  const [tabButtonLoading, setTabButtonLoading] = useState(false);

  const duplicate = location.state
    ? location.state.duplicate
      ? location.state.duplicate
      : false
    : false;

  const productID = location.state
    ? location.state.id
      ? location.state.id
      : 0
    : 0;

  const [formChanged, setFormChanged] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [routeToNavigate, setRouteToNavigate] = useState(null);

  const handleItemClick = () => {

    if (JSON.parse(sessionStorage.getItem('unsavedChanges')) === true) {
  
      setOpenDialog(true);
  
      setRouteToNavigate("/products");
  
    } else {
  
      history.push("/products");
    }
  };
  
  const handleAgree = () => {
  
    sessionStorage.removeItem('unsavedChanges');
    setOpenDialog(false); 
  
    history.push(routeToNavigate);
  };
  
  /*Agreement Form Ref*/
  const productRef = useRef(null);

  useEffect(() => {
    //for drawer menu select
    setPageID(9);

    //for help button
    setPageLink("Products");
  }, []);

  return (
    <>    <ConfirmationPopup
    openDialog={openDialog}
    handleOpenDialog={(v) => setOpenDialog(v)}
    handleAgree={handleAgree}
  />
    <Paper sx={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link
            underline="always"
            key="1"
            color="inherit"
            onClick={() => handleItemClick()}

            sx={{ fontSize: "24px", color: "#0077c6", cursor: "pointer" }}
          >
            Products
          </Link>
          <Typography key="5" color="text.primary" sx={{ fontSize: "24px" }}>
            New Product
          </Typography>
        </Breadcrumbs>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <CustomButton
            startIcon={<Save />}
            toggle={() => productRef.current.save()}
            loading={tabButtonLoading}
          >
            Save
          </CustomButton>
          <div style={{ width: "10px" }} />
          <CustomButton
            startIcon={<X />}
            toggle={async () => {
              await productRef.current.setPristine();
              history.push("/Products");
            }}
          >
            Cancel
          </CustomButton>
        </div>
      </div>
      <div style={{ height: "40px" }} />
      <ProductForm
        create={true}
        duplicate={duplicate}
        receivedProductID={productID}
        ref={productRef}
        setTabButtonLoading={setTabButtonLoading}
        setFormChanged={setFormChanged}
      />
    </Paper></>
  );
};

export default CreateProductPage;
